import { motion } from 'framer-motion';

function Clienti() {
  const listInfo = [
    {
      name: 'Accedere all’area personale per gestire contratti e documenti',
      delay: 0.5,
    },
    {
      name: 'Monitorare le scadenze e ricevere notifiche',
      delay: 0.6,
    },
    {
      name: 'Richiedere preventivi personalizzati',
      delay: 0.7,
    },
    {
      name: 'Parlare con un intermediario dedicato, sempre a disposizione',
      delay: 0.8,
    },
    {
      name: 'Avere tutto sotto controllo, in totale trasparenza',
      delay: 0.9,
    },
  ];

  return (
    <div className="mt-3 pt-5 pt-lg-0">
      <motion.h2
        className="fw-semibold"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Sei un Cliente?
      </motion.h2>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Un’assicurazione più semplice, sempre con te
        Con Greenia, il tuo mondo assicurativo è a portata di mano. Abbiamo creato un’area personale online dove puoi gestire in autonomia i tuoi contratti: visualizzare le polizze attive, scaricare i documenti, monitorare le scadenze e richiedere assistenza in pochi clic. Tutto in un unico spazio, chiaro e sicuro.
        Hai bisogno di una nuova copertura? Con Greenia puoi richiedere un preventivo diretto: ti mettiamo in contatto con un professionista di fiducia che ti guiderà passo dopo passo nella scelta del prodotto più adatto a te. Nessun call center, nessuna attesa: solo consulenza reale, con persone vere.
        Siamo qui per rendere la tua esperienza assicurativa più semplice, veloce e trasparente — senza mai rinunciare alla qualità della relazione umana.
      </motion.p>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.4, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Con Greenia Puoi:</b>
      </motion.p>
      <ul>
        {listInfo.map((item, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: item.delay, duration: 0.5, ease: 'linear' }}
          >
            {item.name}
          </motion.li>
        ))}
      </ul>
    </div>
  );
}

export default Clienti;
